import React, { createContext, useContext, useCallback, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import { SnackbarProvider } from 'notistack';
import 'react-toastify/dist/ReactToastify.css';
import 'animate.css';
import { animateCss } from '../utils/animateCss';

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const addToast = useCallback((message, type = 'success') => {
    animateCss(type, message);
  }, []);

  const toast = useMemo(
    () => ({
      success: (msg) => animateCss('success', msg),
      error: (msg) => animateCss('error', msg),
      info: (msg) => animateCss('info', msg),
      warn: (msg) => animateCss('warn', msg),
      default: (msg) => animateCss('default', msg),
    }),
    []
  );

  return (
    <ToastContext.Provider value={{ toast, addToast }}>
      <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {children}
      </SnackbarProvider>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        newestOnTop
        closeOnClick
        draggable
        className="toastify-container"
      />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
